// constants
import { TestimonialsActionTypes } from './constants';

const INIT_STATE = {
    testimonials: [],
    testimonial: {},
    page: 1,
    limit: 10,
    totalPages: 0,
    totalResults: 0,
    loading: false,
    hasErrors: false,
    submitted: false,
    isDeleted: false,
};

interface TestimonialsActionType {
    type:
    | TestimonialsActionTypes.API_RESPONSE_SUCCESS
    | TestimonialsActionTypes.API_RESPONSE_ERROR
    | TestimonialsActionTypes.TESTIMONIALS_LIST
    | TestimonialsActionTypes.ADD_TESTIMONIALS
    | TestimonialsActionTypes.SHOW_TESTIMONIALS
    | TestimonialsActionTypes.UPDATE_TESTIMONIALS

    payload: {
        actionType?: string;
        responseData?: any;
        error?: any;
        validationError?: { error: string; key: string; }[];
        hasErrors: boolean,
        submitted: boolean,
        isDeleted: boolean,
    };
}

interface State {
    testimonials: any;
    testimonial: any;
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
}

const Testimonials = (state: State = INIT_STATE, action: TestimonialsActionType): any => {
    switch (action.type) {
        case TestimonialsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload?.actionType) {  
                case TestimonialsActionTypes.TESTIMONIALS_LIST: {
                    return {
                        ...state,
                        testimonials: action.payload?.responseData?.data,
                        page: action.payload?.responseData?.page,
                        limit: action.payload?.responseData?.limit,
                        totalPages: action.payload?.responseData?.totalPages,
                        totalResults: action.payload?.responseData?.totalResults,
                        loading: true,
                        submitted: false,
                    };
                }
                case TestimonialsActionTypes.ADD_TESTIMONIALS: {
                    return {
                        ...state,
                        testimonials: [...state.testimonials, action.payload?.responseData?.data],
                        totalResults: (action.payload?.responseData?.totalResults ? (action.payload?.responseData?.totalResults + 1) : 0),
                        hasErrors: false,
                        loading: true,
                        submitted: true,
                    };
                }
                case TestimonialsActionTypes.SHOW_TESTIMONIALS: {
                    return {
                        ...state,
                        testimonial: action.payload?.responseData?.data,
                        hasErrors: false,
                        loading: true,
                        submitted: true,
                    };
                }
                case TestimonialsActionTypes.UPDATE_TESTIMONIALS: {
                    const updatedTestimonials = action.payload?.responseData?.data;
                    const allSubs = state.testimonials;
                    const updatedSubs= allSubs.map((cat: any) => cat.id === updatedTestimonials.id ? updatedTestimonials : cat);
                    return {
                        ...state,
                        testimonials: updatedSubs,
                        hasErrors: false,
                        loading: true,
                        submitted: true,
                    };
                }
                case TestimonialsActionTypes.DELETE_TESTIMONIALS: {
                    const deletedId = action.payload?.responseData?.deletedId;
                    const allSubs = state.testimonials;
                    const updatedSubs = allSubs.filter((cat: any) => cat.id !== deletedId);
                    return {
                        ...state,
                        testimonials: updatedSubs,
                        loading: true,
                        hasErrors: false,
                        submitted: false,
                        isDeleted: true,
                    };
                }
                default:
                    return { ...state };
            }

        case TestimonialsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload?.actionType) {
                case TestimonialsActionTypes.TESTIMONIALS_LIST: {
                    return {
                        ...state,
                        error: action.payload.error,
                        hasErrors: true,
                        loading: true,
                        submitted: false,
                    };
                }
                case TestimonialsActionTypes.ADD_TESTIMONIALS: {
                    return {
                        ...state,
                        error: action.payload?.error,
                        validationError: action.payload?.error,
                        hasErrors: true,
                        loading: true,
                        submitted: true,
                    };
                }
                case TestimonialsActionTypes.SHOW_TESTIMONIALS: {
                    return {
                        ...state,
                        error: action.payload?.error,
                        validationError: action.payload?.error,
                        hasErrors: true,
                        loading: true,
                        submitted: true,
                    };
                }
                case TestimonialsActionTypes.UPDATE_TESTIMONIALS: {
                    return {
                        ...state,
                        error: action.payload?.error,
                        validationError: action.payload?.error,
                        hasErrors: true,
                        loading: true,
                        submitted: true,
                    };
                }
                default:
                    return { ...state };
            }
        default:
            return { ...state };
    }
};

export default Testimonials;
